<section *ngIf="!isLoading">
    <div class="hero-image">
        <xm-media-image [imageOptions]="imageOptions" center="auto" size="height"></xm-media-image>
    </div>
    <div [class.no-cta]="isNoCta" class="hero-content">
        <h2 [innerHtml]="heading"></h2>
        <cms-text *ngIf="description" class="description" [originalText]="description"></cms-text>
        <cms-text *ngIf="body" class="body" [originalText]="body"></cms-text>
    </div>
    <div class="hero-cta">
        <a *ngIf="buttonAttributes && buttonAttributes.hasInternalLink && buttonText" [uiSref]="buttonAttributes.uiSref" [uiParams]="buttonAttributes.uiParams" class="xm-btn-primary-light cta">{{ buttonText }}</a>
        <a *ngIf="buttonAttributes && (buttonAttributes.hasExternalLink && !buttonAttributes.openInSameTab) && buttonText" [href]="buttonAttributes.href" rel="noopener" target="_blank" class="xm-btn-primary-light cta">{{ buttonText }}</a>
        <a *ngIf="buttonAttributes && (buttonAttributes.hasExternalLink && buttonAttributes.openInSameTab) && buttonText" [href]="buttonAttributes.href" class="xm-btn-primary-light cta">{{ buttonText }}</a>
        <button *ngIf="buttonAttributes && buttonAttributes.hasButton && buttonText" (click)="goToCtaAction()" class="xm-btn-primary-light cta">{{ buttonText }}</button>
    </div>
</section>
<section *ngIf="isLoading">
    <xm-loader-overlay [type]="'banner'"></xm-loader-overlay>
</section>
